import http from 'hub-http/clients/noAuthApiClient';
export const setReauthCookie = reauthCookie => http.post('login-api/v1/login/mobile/reauth-cookie', {
  data: {
    hsReauth: reauthCookie
  }
});